// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__mtAb6","content":"Layout_content__88Srk"};